import { gsap, ScrollTrigger } from "../layout";

// bootstrap
import Tab from 'bootstrap/js/dist/tab';
import Dropdown from 'bootstrap/js/dist/dropdown';
// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

function goalsSection() {
    // vision mission card match height
    const visionMissionCards = document.querySelectorAll('.goals__vision-mission-item');
    matchHeight(visionMissionCards);
}

function historySection() {
    var historySwiper = new Swiper(".history__swiper", {
        modules: [ Pagination, Navigation, Autoplay, EffectFade ],
        effect: "fade",
        initialSlide: document.querySelectorAll('.history__swiper .swiper-slide').length - 1,
        pagination: {
            el: ".history__pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".history__next",
            prevEl: ".history__prev",
        },
    });
}

function timelineSection() {
    // remove element responsive
    const timelineNavDesktop = document.querySelector('.timeline__nav-menu');
    const timelineDropdownMobile = document.querySelector('.timeline__dropdown');
    if (window.innerWidth < 992) {
        timelineNavDesktop.remove();
    } else {
        timelineDropdownMobile.remove();
    }

    // refresh scroll trigger on click
    const timelineNavLink = document.querySelectorAll('.timeline__nav-link');
    timelineNavLink.forEach((item) => {
        item.addEventListener('click', () => {
            ScrollTrigger.refresh();
            gsap.to(window, { duration: 0, scrollTo: { y: `.timeline`, offsetY: 50} });
        })
    })

    // sidebar pin
    const timelineSection = document.querySelector(".timeline");
    const timelineSidebar = document.querySelector(".timeline__sidebar");
    let mm = gsap.matchMedia()
    mm.add("(min-width: 1025px)", () => {
        ScrollTrigger.create({
            trigger: timelineSection,
            pin: timelineSidebar,
            start: "top top",
            end: "bottom bottom-=20%",
            // markers: true
        });
    })

    // Load More Button
    const tabPanes = document.querySelectorAll(".tab-pane");
    tabPanes.forEach(tabPane => {
        const items = tabPane.querySelectorAll(".timeline__item");
        const loadMoreButton = tabPane.querySelector(".timeline__load-more-button");

        const initialVisibleCount = 3; // Jumlah item yang terlihat awalnya
        let hasLoaded = false; // untuk memastikan hanya satu kali load

        // Tampilkan elemen awal
        const updateVisibleItems = () => {
            items.forEach((item, index) => {
                if (index < initialVisibleCount) {
                    item.classList.add("visible");
                } else {
                    item.classList.remove("visible");
                }
            });

            // Sembunyikan tombol jika semua elemen sudah terlihat
            if (hasLoaded || initialVisibleCount >= items.length) {
                loadMoreButton.style.display = "none";
            }
        };

        // Event klik untuk tombol Load More
        loadMoreButton.addEventListener("click", () => {
            if (!hasLoaded) {
                // Tampilkan semua elemen
                items.forEach(item => item.classList.add("visible"));
                hasLoaded = true; // Tandai sebagai sudah di-load
                loadMoreButton.style.display = "none"; // Sembunyikan tombol
            }
            ScrollTrigger.refresh();
        });

        // Inisialisasi
        updateVisibleItems();
    });

    // dropdown menu on mobile
    const timelineDropdownItem = document.querySelectorAll('.timeline__dropdown-item');
    const timelineDropdownToggle = document.querySelector('.timeline__dropdown-toggle');
    if (window.innerWidth < 992) {
        timelineDropdownItem.forEach(el => {
            el.addEventListener('click', () => {
                timelineDropdownToggle.innerHTML = el.textContent;
            })
        })
    }
}

function otherSection() {
    if (window.innerWidth < 992) {
        let cols = document.querySelectorAll(".info-others__col .col-6");
        if (cols.length % 2 !== 0) {
          cols[cols.length - 1].classList.remove("col-6");
          cols[cols.length - 1].classList.add("col-12");
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    goalsSection();
    historySection();
    timelineSection();
    otherSection();
})

window.addEventListener('resize', () => {
    goalsSection();
})